import { Button, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import FacebookImg from "../assests/s1.svg";
import GoogleImg from "../assests/s2.svg";
import ShopifyImg from "../assests/s3.svg";
import metaImg from "../assests/meta_logo.avif";
import studioImg from "../assests/studio_logo.avif";
import ytShortsImg from "../assests/yt_shorts.avif";
import google_adsImg from "../assests/google_ads.avif";
import logo from "../assests/gromedia_bg_black.png"
import GroMediaBanner from "../assests/gromedia_banner.png"

const HeroSection = ({ handleClick }) => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(380));

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            background: '#000',
            paddingBottom: isSmall ? 50 : 100,
            paddingTop: isMobile ? 25 : 60,
            boxSizing: 'border-box'
        },
        subContainer: {
            width: isMobile ? '90%' : isBig ? '90%' : '80%',
        },
        logoContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        logo: {
            color: '#fff',
            fontSize: isMobile ? 30 : 40
        },
        heading: {
            fontSize: isMobile ? '12px' : '16px',
            textAlign: 'center',
            boxSizing: 'border-box',
            marginTop: isMobile ? 10 : 10
        },
        headingText: {
            backgroundColor: 'rgb(255, 210, 48)',
            fontWeight: 700,
            padding: isSmall ? '8px 15px' : '12px 25px',
            borderRadius: '5px',
            boxSizing: 'border-box',
            fontSize: isMobile ? 10 : 15
        },
        headingTwo: {
            marginTop: 40,
            color: 'white',
            fontSize: isMobile ? 20 : 40,
            fontWeight: 'bold',
            textAlign: 'center',
            width: isMobile ? '100%' : '80%',
            margin: '40px auto'
        },
        headingThree: {
            marginTop: 30,
            display: 'flex',
            justifyContent: 'center',
            color: 'white',
            fontSize: isMobile ? 15 : 25,
            textAlign: 'center'
        },
        heroImage: {
            marginTop: 40
        },
        headingFour: {
            marginTop: 40,
            color: '#fff',
            textAlign: 'center',
            fontSize: isMobile ? 15 : '25px',
            color: '#b6b6b6'
        },
        buttonContainer: {
            marginTop: 20,
            textAlign: 'center',
        },
        button: {
            borderRadius: '30px',
            color: 'black',
            backgroundColor: 'rgb(255, 210, 48)',
            padding: isMobile ? '10px 30px' : '15px 60px',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: isMobile ? '12px' : '16px',
            '&:hover': {
                backgroundColor: 'rgb(255, 210, 48)',
                color: '#fff'
            }
        },
        socialContainer: {
            marginTop: 40,
            display: 'flex',
            justifyContent: 'space-evenly',
            flexWrap: 'wrap',
            rowGap: '20px',
        },

    }


    return (
        <div style={styles.container}>
            <div style={styles.subContainer}>
                <div style={styles.logoContainer}>
                    <span style={styles.logo}>
                        <img src={logo} alt="logo" />
                    </span>
                </div>
                <div style={styles.heading}>
                    <span style={styles.headingText}>For E-com Fashion Brand Above ₹1L/Month</span>
                </div>

                <div style={styles.headingTwo}>
                    <span>How We Help D2C Fashion Brands Scale to </span>
                    <span style={{ color: 'rgb(255, 210, 48)', display: 'inline-block' }}>₹1 CRORE+ </span>
                    <span> Per Month In Less than</span>
                    <span style={{ color: 'rgb(255, 210, 48)' }}> 180 Days</span>
                </div>

                <div style={styles.headingThree}>With Creative Focused Advertising & Performance Creatives</div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                    {
                        !isBig
                        &&
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', flexDirection: 'column' }}>
                            <div style={{ background: '#192439', padding: '20px 10px', marginRight: 70, border: '1px solid #495571', borderRadius: 15 }}>
                                <img src={metaImg} style={{ width: 70 }} ></img>
                            </div>

                            <div style={{ background: '#192439', padding: '10px 10px', border: '1px solid #495571', borderRadius: 15, marginLeft: 'auto', marginRight: 20 }}>
                                <img src={google_adsImg} style={{ width: 70 }}></img>
                            </div>
                        </div>
                    }

                    <div style={styles.heroImage}>
                        <img src={GroMediaBanner} style={{ width: '100%', height: '100%', border: '5px solid rgb(255, 210, 48)', borderRadius: 5 }} ></img>
                    </div>

                    {
                        !isBig
                        &&
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', flexDirection: 'column' }}>
                            <div style={{ background: '#192439', padding: '10px 10px', border: '1px solid #495571', borderRadius: 15, marginLeft: '70px' }}>
                                <img src={studioImg} style={{ width: 70 }} ></img>
                            </div>

                            <div style={{ background: '#192439', padding: '10px 10px', border: '1px solid #495571', borderRadius: 15, marginRight: 'auto', marginLeft: 20 }}>
                                <img src={ytShortsImg} style={{ width: 70 }} ></img>
                            </div>

                        </div>
                    }

                </div>

                <div style={styles.headingFour}>Let’s scale your brand to 10000+ orders per month profitably!</div>

                <div style={styles.buttonContainer}>
                    <Button sx={styles.button} onClick={handleClick}>Let's Connect</Button>
                </div>


                <div style={styles.socialContainer}>
                    <img src={FacebookImg} style={{ width: isSmall ? 60 : 100 }} ></img>
                    <img src={GoogleImg} style={{ width: isSmall ? 60 : 100 }} ></img>
                    <img src={ShopifyImg} style={{ width: isSmall ? 100 : 180 }} ></img>
                </div>
            </div>
        </div >
    )
}



export default HeroSection;